import { Injectable } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';

@Injectable({
    providedIn: 'root',
})
export class DynamicDialogConfigService {
    private isMobile(): boolean {
        return window.innerWidth <= 1000;
    }

    getConfig(): DynamicDialogConfig {
        if (this.isMobile()) {
            return {
                closable: true,
                width: '100vw',
                style: { 'max-height': '80vh', overflow: 'auto' },
                baseZIndex: 10000,
            };
        } else {
            return {
                closable: true,
                width: '50vw',
                style: { 'max-height': '90vh', overflow: 'auto' },
                baseZIndex: 10000,
            };
        }
    }
}
